import React from 'react';
import image1 from '../assets/background.jpeg';
import { Image } from 'antd';
import { useMediaQuery } from 'react-responsive';

const overlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  fontSize: '27px',
  width: '100%',
  backgroundColor: 'rgb(7 32 53 / 68%)',
  color: '#fff',
  padding: '10px',
  textAlign: 'center',
};
const SearchAssets = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '40px' }}>الاستعلام عن العهد</h1>
        <h3 style={{ fontSize: '25px' }}>
          ملاحظة: خدمة الاستعلام تعمل فقط داخل شبكة الجامعة
        </h3>
      </div>
      <div
        style={{
          display: !isTabletOrMobile ? 'flex' : 'grid',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        <div
          style={{ margin: '20px' }}
          onClick={() =>
            window.open('http://stores.kuniv.edu.kw/page011.aspx', '_blank')
          }
        >
          {image1 && (
            <div style={{ position: 'relative', cursor: 'pointer' }}>
              <Image
                preview={false}
                width={'500px'}
                src={image1}
                alt='Uploaded'
              />
              <div style={overlayStyle}>استعلام العهد بالرقم المسلسل</div>
            </div>
          )}
        </div>
        <div
          style={{ margin: '20px' }}
          onClick={() =>
            window.open('http://stores.kuniv.edu.kw/page001.aspx', '_blank')
          }
        >
          {image1 && (
            <div style={{ position: 'relative', cursor: 'pointer' }}>
              <Image
                width={'500px'}
                preview={false}
                src={image1}
                alt='Uploaded'
              />
              <div style={overlayStyle}>استعلام العهد بالرقم الوظيفي</div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SearchAssets;
